<div class="row">   
    <div class="text-right" *ngIf="!productsService?.catalogMode">
      <ul class="header-dropdown">
              <li class="onhover-dropdown mobile-account" [class.active]="isOpen" (click)="toggleMenu()">
                <span class="material-icons icon-header" aria-hidden="true">person</span> <span class="account-name">{{ name  }}</span>
          <ul class="onhover-show-div" [class.open]="isOpen">
            <li *ngIf="!customer"> 
              <a [routerLink]="'/pages/login'" data-lng="en">
                  {{ 'login' | translate }}
              </a>
            </li>
            <li *ngIf="customer"> 
              <a [routerLink]="'/pages/mi-perfil'" data-lng="en">
                  {{ 'miperfil' | translate }}
              </a>
            </li>
            <li *ngIf="customer">
                <a [routerLink]="'/pages/updatedPriceList'" data-lng="en">
                    {{ 'actualizacion-precios' | translate }}
                </a>
              </li>
            <li *ngIf="customer">
              <a (click)="logout()" data-lng="es">
                  {{ 'logout' | translate }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
</div>





